/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import App from './App.vue'
import request from '@/utils/ajax';
import Vue from 'vue'
import Router from 'vue-router'
import { filterAsyncRouter } from '@/utils/common'
import store from './store/store.js'
Vue.use(Router)

export const constantRouterMap = [
  // 登录之后 todo默认跳转的是首页
  {
    path: '',
    component: () => import('@/layouts/main/Main.vue'),
    children: [
      {
        path: '',
        component: () => import( '@/views/Home'),
        name: 'home',
        meta: {
          title: '首页',
        }
      },
    ],
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "商户管理",
    },
    children: [

      {
        path: 'merchantList',
        component: () => import('@/views/merchant/productList/index'),
        name: 'merchantList',
        meta: {
          title: '商户列表',
        }
      },
      {
        path: 'productAssociationlist',
        component: () => import('@/views/merchant/productAssociationlist/index'),
        name: 'productAssociationlist',
        meta: {
          title: '产品关联表',
        }
      },
    ]
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "产品管理",
    },
    children: [
      {
        path: 'productList',
        component: () => import('@/views/product/productList/index'),
        name: 'productList',
        meta: {
          title: '产品列表',
        }
      },
      {
        path: 'channelAssociationlist',
        component: () => import('@/views/product/channelAssociationlist/index'),
        name: 'channelAssociationlist',
        meta: {
          title: '渠道关联表',
        }
      },

    ]
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "产品管理",
    },
    children:[
      {
        path: 'channelManage',
        component: () => import('@/views/product/channelManage/index'),
        name: 'channelManage',
        meta: {
          title: '渠道管理',
        }
      },
    ]
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "产品管理",
    },
    children:[
      {
        path: 'orderManage',
        component: () => import('@/views/product/orderManage/index'),
        name: 'orderManage',
        meta: {
          title: '订单管理',
        }
      },
    ]
  },
  {
    path: "",
    component: () => import('@/layouts/main/Main.vue'),
    meta: {
      title: "钱包管理",
    },
    children: [
      {
        path: 'walletInfo',
        component: () => import('@/views/walletManage/walletInfo/index'),
        name: 'walletInfo',
        meta: {
          title: '钱包信息',
        }
      },
      {
        path: 'customerManage',
        component: () => import('@/views/walletManage/customerManage/index'),
        name: 'customerManage',
        meta: {
          title: '客户管理',
        },
      },
      {
        path: 'customerDetail/:id',
        component: () => import('@/views/walletManage/customerManage/customerDetail'),
        name: 'customerDetail',
        meta: {
          title: '客户详情',
        },
      },
      {
        path: 'assetTurnover',
        component: () => import('@/views/walletManage/assetTurnover/index'),
        name: 'assetTurnover',
        meta: {
          title: '资产流水',
        }
      },
      {
        path: 'apiTurnover',
        component: () => import('@/views/walletManage/apiTurnover/index'),
        name: 'apiTurnover',
        meta: {
          title: '商户流水',
        }
      },
      {
        path: 'apiTurnoverDetail/:id',
        component: () => import('@/views/walletManage/apiTurnover/apiTurnoverDetail'),
        name: 'apiTurnoverDetail',
        meta: {
          title: '流水详情',
        }
      },
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue')
      },
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login.vue')
      },
    ]
  },
  {
    path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
    children: [
      {
        path: '/cashier',
        name: 'cashier',
        component: () => import('@/views/cashier.vue')
      },
    ]
  },
];

const router = new Router({
    mode: 'history',
    // base: ,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: constantRouterMap,
});


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});
export default router
